interface Props {}

function PageReportUpload(props: Props) {
  return <>Page report upload works!</>;
}

export default PageReportUpload;
